import { z } from 'zod';

import {
  ModelSortDirection,
  CardDriverRankingDriverInfoInput,
  CardGpCalendarGpInfoInput,
  CardGpResultsResultInfoInput,
  CardGpResultsResultInfoTimingInput,
  CardTeamRankingTeamInfoInput,
  CreateCardDriverRankingWidgetInput,
  CreateCardGpCalendarWidgetInput,
  CreateCardGpResultsWidgetInput,
  CreateCardTeamRankingWidgetInput,
  CreateCompetitionInput,
  CreateCrossLinkInput,
  CreateDriverInput,
  CreateDriverRankingWidgetInput,
  CreateEditorialDataInput,
  CreateGpCalendarWidgetInput,
  CreateGpCurrentCalendarWidgetInput,
  CreateGpDataInput,
  CreateGpLiveContainerWidgetInput,
  CreateGpLiveHeroWidgetInput,
  CreateGpPodiumListWidgetInput,
  CreateGpResultsContainerWidgetInput,
  CreateGpResultsWidgetInput,
  CreateGrandPrixInput,
  CreateLgpHeroStickyWidgetInput,
  CreateLgpHeroWidgetInput,
  CreateLgpPreviewWidgetInput,
  CreateLgpResultsContainerWidgetInput,
  CreateLgpResultsWidgetInput,
  CreateLiveScoreWidgetInput,
  CreateSeasonInput,
  CreateSeasonRankingGalleryWidgetInput,
  CreateSessionInput,
  CreateTeamDriverPageWidgetInput,
  CreateTeamInput,
  CreateTeamRankingWidgetInput,
  DeleteCardDriverRankingWidgetInput,
  DeleteCardGpCalendarWidgetInput,
  DeleteCardGpResultsWidgetInput,
  DeleteCardTeamRankingWidgetInput,
  DeleteCompetitionInput,
  DeleteCrossLinkInput,
  DeleteDriverInput,
  DeleteDriverRankingWidgetInput,
  DeleteEditorialDataInput,
  DeleteGpCalendarWidgetInput,
  DeleteGpCurrentCalendarWidgetInput,
  DeleteGpDataInput,
  DeleteGpLiveContainerWidgetInput,
  DeleteGpLiveHeroWidgetInput,
  DeleteGpPodiumListWidgetInput,
  DeleteGpResultsContainerWidgetInput,
  DeleteGpResultsWidgetInput,
  DeleteGrandPrixInput,
  DeleteLgpHeroStickyWidgetInput,
  DeleteLgpHeroWidgetInput,
  DeleteLgpPreviewWidgetInput,
  DeleteLgpResultsContainerWidgetInput,
  DeleteLgpResultsWidgetInput,
  DeleteLiveScoreWidgetInput,
  DeleteSeasonInput,
  DeleteSeasonRankingGalleryWidgetInput,
  DeleteSessionInput,
  DeleteTeamDriverPageWidgetInput,
  DeleteTeamInput,
  DeleteTeamRankingWidgetInput,
  DriverRankingDriverInfoInput,
  DriverRankingDriverInput,
  GpCalendarGpInfoInput,
  GpCalendarItemInput,
  GpCalendarItemSessionsInput,
  GpCalendarSessionInfoInput,
  GpCalendarSessionInput,
  GpLiveContainerWrapperAttributesInput,
  GpLiveContainerWrapperInput,
  GpLiveHeroGpInfoInput,
  GpPodiumListGpInfoInput,
  GpPodiumListGrandPrixInput,
  GpPodiumListSessionInfoDetailsInput,
  GpPodiumListSessionInfoDetailsPointsInput,
  GpPodiumListSessionInfoDetailsTeamInput,
  GpPodiumListSessionInfoDetailsTimingInput,
  GpPodiumListSessionInfoInput,
  GpPodiumListSessionInput,
  GpResultsContainerWrapperAttributesInput,
  GpResultsContainerWrapperInput,
  GpResultsGpInfoInput,
  GpResultsSessionInfoDetailsInput,
  GpResultsSessionInfoDetailsPointsInput,
  GpResultsSessionInfoDetailsTeamInput,
  GpResultsSessionInfoDetailsTimingInput,
  GpResultsSessionInfoInput,
  GpResultsSessionInput,
  LgpHeroInfoInput,
  LgpHeroPodiumInput,
  LgpHeroSessionInput,
  LgpHeroStickyInfoInput,
  LgpHeroStickySessionInput,
  LgpInfoLinkInput,
  LgpPreviewSessionInput,
  LgpResultsContainerWrapperAttributesInput,
  LgpResultsContainerWrapperInput,
  LgpResultsGpInfoInput,
  LgpResultsSessionInfoDetailsInput,
  LgpResultsSessionInfoDetailsTimingInput,
  LgpResultsSessionInfoInput,
  LgpResultsSessionInput,
  LiveScoreWidgetDayInput,
  LiveScoreWidgetGpInfoInput,
  LiveScoreWidgetResultsInput,
  LiveScoreWidgetResultsTimingInput,
  LiveScoreWidgetSessionInput,
  ModelBooleanFilterInput,
  ModelCardDriverRankingWidgetFilterInput,
  ModelCardGpCalendarWidgetFilterInput,
  ModelCardGpResultsWidgetFilterInput,
  ModelCardTeamRankingWidgetFilterInput,
  ModelCompetitionFilterInput,
  ModelCrossLinkFilterInput,
  ModelDriverFilterInput,
  ModelDriverRankingWidgetFilterInput,
  ModelEditorialDataFilterInput,
  ModelFloatFilterInput,
  ModelGpCalendarWidgetFilterInput,
  ModelGpCurrentCalendarWidgetFilterInput,
  ModelGpDataFilterInput,
  ModelGpLiveContainerWidgetFilterInput,
  ModelGpLiveHeroWidgetFilterInput,
  ModelGpPodiumListWidgetFilterInput,
  ModelGpResultsContainerWidgetFilterInput,
  ModelGpResultsWidgetFilterInput,
  ModelGrandPrixFilterInput,
  ModelIntFilterInput,
  ModelLgpHeroStickyWidgetFilterInput,
  ModelLgpHeroWidgetFilterInput,
  ModelLgpPreviewWidgetFilterInput,
  ModelLgpResultsContainerWidgetFilterInput,
  ModelLgpResultsWidgetFilterInput,
  ModelLiveScoreWidgetFilterInput,
  ModelSeasonFilterInput,
  ModelSeasonRankingGalleryWidgetFilterInput,
  ModelSessionFilterInput,
  ModelStringFilterInput,
  ModelStringKeyConditionInput,
  ModelTeamDriverPageWidgetFilterInput,
  ModelTeamFilterInput,
  ModelTeamRankingWidgetFilterInput,
  S3Object,
  SeasonDriverRankingInput,
  SeasonTeamRankingInput,
  TeamDriverDriverInput,
  TeamDriverTeamInput,
  TeamRankingTeamInput,
  UpdateCardDriverRankingWidgetInput,
  UpdateCardGpCalendarWidgetInput,
  UpdateCardGpResultsWidgetInput,
  UpdateCardTeamRankingWidgetInput,
  UpdateCompetitionInput,
  UpdateCrossLinkInput,
  UpdateDriverInput,
  UpdateDriverRankingWidgetInput,
  UpdateEditorialDataInput,
  UpdateGpCalendarWidgetInput,
  UpdateGpCurrentCalendarWidgetInput,
  UpdateGpDataInput,
  UpdateGpLiveContainerWidgetInput,
  UpdateGpLiveHeroWidgetInput,
  UpdateGpPodiumListWidgetInput,
  UpdateGpResultsContainerWidgetInput,
  UpdateGpResultsWidgetInput,
  UpdateGrandPrixInput,
  UpdateLgpHeroStickyWidgetInput,
  UpdateLgpHeroWidgetInput,
  UpdateLgpPreviewWidgetInput,
  UpdateLgpResultsContainerWidgetInput,
  UpdateLgpResultsWidgetInput,
  UpdateLiveScoreWidgetInput,
  UpdateSeasonInput,
  UpdateSeasonRankingGalleryWidgetInput,
  UpdateSessionInput,
  UpdateTeamDriverPageWidgetInput,
  UpdateTeamInput,
  UpdateTeamRankingWidgetInput,
} from './graphql';

type Properties<T> = Required<{
  [K in keyof T]: z.ZodTypeAny;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export const ModelSortDirectionSchema = z.nativeEnum(ModelSortDirection);

export function CardDriverRankingDriverInfoInputSchema(): z.ZodObject<Properties<CardDriverRankingDriverInfoInput>> {
  return z.object({
    customDriverName: z.string().nullish(),
    customDriverPageUrl: z.string().nullish(),
    customDriverSurname: z.string().nullish(),
    flagUrl: z.string().nullish(),
    pos: z.string().nullish(),
    pts: z.string().nullish(),
  });
}

export function CardGpCalendarGpInfoInputSchema(): z.ZodObject<Properties<CardGpCalendarGpInfoInput>> {
  return z.object({
    customGpName: z.string().nullish(),
    endDateTime: z.string().nullish(),
    flagUrl: z.string().nullish(),
    isExclusive: z.boolean().nullish(),
    lgpPreviewUrl: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function CardGpResultsResultInfoInputSchema(): z.ZodObject<Properties<CardGpResultsResultInfoInput>> {
  return z.object({
    customDriverName: z.string().nullish(),
    customDriverPageUrl: z.string().nullish(),
    customDriverSurname: z.string().nullish(),
    flagUrl: z.string().nullish(),
    gap: z.string().nullish(),
    pos: z.string().nullish(),
    timing: z.lazy(() => CardGpResultsResultInfoTimingInputSchema().nullish()),
  });
}

export function CardGpResultsResultInfoTimingInputSchema(): z.ZodObject<
  Properties<CardGpResultsResultInfoTimingInput>
> {
  return z.object({
    timeHours: z.string().nullish(),
    timeMilliseconds: z.string().nullish(),
    timeMinutes: z.string().nullish(),
    timeSeconds: z.string().nullish(),
  });
}

export function CardTeamRankingTeamInfoInputSchema(): z.ZodObject<Properties<CardTeamRankingTeamInfoInput>> {
  return z.object({
    customTeamName: z.string().nullish(),
    customTeamPageUrl: z.string().nullish(),
    logoUrl: z.string().nullish(),
    pos: z.string().nullish(),
    pts: z.string().nullish(),
  });
}

export function CreateCardDriverRankingWidgetInputSchema(): z.ZodObject<
  Properties<CreateCardDriverRankingWidgetInput>
> {
  return z.object({
    competitionId: z.string(),
    customCompetitionName: z.string().nullish(),
    drivers: z.array(z.lazy(() => CardDriverRankingDriverInfoInputSchema().nullable())).nullish(),
    rankingLink: z.string().nullish(),
  });
}

export function CreateCardGpCalendarWidgetInputSchema(): z.ZodObject<Properties<CreateCardGpCalendarWidgetInput>> {
  return z.object({
    calendarLink: z.string().nullish(),
    competitionId: z.string(),
    customCompetitionName: z.string().nullish(),
    gpList: z.array(z.lazy(() => CardGpCalendarGpInfoInputSchema().nullable())).nullish(),
  });
}

export function CreateCardGpResultsWidgetInputSchema(): z.ZodObject<Properties<CreateCardGpResultsWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    customCompetitionName: z.string().nullish(),
    customGpName: z.string().nullish(),
    isSprint: z.boolean().nullish(),
    results: z.array(z.lazy(() => CardGpResultsResultInfoInputSchema().nullable())).nullish(),
    resultsLink: z.string().nullish(),
  });
}

export function CreateCardTeamRankingWidgetInputSchema(): z.ZodObject<Properties<CreateCardTeamRankingWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    customCompetitionName: z.string().nullish(),
    rankingLink: z.string().nullish(),
    teams: z.array(z.lazy(() => CardTeamRankingTeamInfoInputSchema().nullable())).nullish(),
  });
}

export function CreateCompetitionInputSchema(): z.ZodObject<Properties<CreateCompetitionInput>> {
  return z.object({
    competitionId: z.string(),
    competitionJson: z.any(),
    editorialDataId: z.string(),
    previousSeasonAndCompId: z.string().nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
  });
}

export function CreateCrossLinkInputSchema(): z.ZodObject<Properties<CreateCrossLinkInput>> {
  return z.object({
    crossLinkJson: z.any(),
    gpId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function CreateDriverInputSchema(): z.ZodObject<Properties<CreateDriverInput>> {
  return z.object({
    driverId: z.string(),
    driverJson: z.any(),
    editorialDataId: z.string(),
    seasonAndCompId: z.string(),
    teamId: z.string(),
  });
}

export function CreateDriverRankingWidgetInputSchema(): z.ZodObject<Properties<CreateDriverRankingWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    competitionLabel: z.string().nullish(),
    items: z.array(z.lazy(() => DriverRankingDriverInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
  });
}

export function CreateEditorialDataInputSchema(): z.ZodObject<Properties<CreateEditorialDataInput>> {
  return z.object({
    editorialDataId: z.string(),
    editorialJson: z.any(),
    isCurrent: z.boolean().nullish(),
    seasonAndCompId: z.string(),
  });
}

export function CreateGpCalendarWidgetInputSchema(): z.ZodObject<Properties<CreateGpCalendarWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    items: z.array(z.lazy(() => GpCalendarItemInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
  });
}

export function CreateGpCurrentCalendarWidgetInputSchema(): z.ZodObject<
  Properties<CreateGpCurrentCalendarWidgetInput>
> {
  return z.object({
    competitionId: z.string(),
    items: z.array(z.lazy(() => GpCalendarItemInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
  });
}

export function CreateGpDataInputSchema(): z.ZodObject<Properties<CreateGpDataInput>> {
  return z.object({
    competitionId: z.string(),
    data: z.any(),
    gpId: z.string(),
    messageType: z.string(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
  });
}

export function CreateGpLiveContainerWidgetInputSchema(): z.ZodObject<Properties<CreateGpLiveContainerWidgetInput>> {
  return z.object({
    DS: z.lazy(() => GpLiveContainerWrapperInputSchema().nullish()),
    G: z.lazy(() => GpLiveContainerWrapperInputSchema().nullish()),
    R: z.lazy(() => GpLiveContainerWrapperInputSchema().nullish()),
    TS: z.lazy(() => GpLiveContainerWrapperInputSchema().nullish()),
    competitionId: z.string(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
  });
}

export function CreateGpLiveHeroWidgetInputSchema(): z.ZodObject<Properties<CreateGpLiveHeroWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    gpInfo: z.lazy(() => GpLiveHeroGpInfoInputSchema().nullish()),
    isCurrent: z.boolean().nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
  });
}

export function CreateGpPodiumListWidgetInputSchema(): z.ZodObject<Properties<CreateGpPodiumListWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    grandPrixList: z.array(z.lazy(() => GpPodiumListGrandPrixInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
  });
}

export function CreateGpResultsContainerWidgetInputSchema(): z.ZodObject<
  Properties<CreateGpResultsContainerWidgetInput>
> {
  return z.object({
    FP1: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    FP2: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    FP3: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    FP4: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    G: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    GS: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    Q: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    QS: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    R: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    SPRINT: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    SS: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    competitionId: z.string(),
    gpId: z.string(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
  });
}

export function CreateGpResultsWidgetInputSchema(): z.ZodObject<Properties<CreateGpResultsWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    gpId: z.string(),
    gpInfo: z.lazy(() => GpResultsGpInfoInputSchema().nullish()),
    gpStatus: z.string().nullish(),
    isCurrent: z.boolean().nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
    sessionName: z.string(),
    sessions: z.array(z.lazy(() => GpResultsSessionInputSchema().nullable())).nullish(),
  });
}

export function CreateGrandPrixInputSchema(): z.ZodObject<Properties<CreateGrandPrixInput>> {
  return z.object({
    date: z.string().datetime().nullish(),
    editorialDataId: z.string(),
    gpId: z.string(),
    gpJson: z.any().nullish(),
    isCurrent: z.boolean().nullish(),
    seasonAndCompId: z.string(),
    status: z.string().nullish(),
  });
}

export function CreateLgpHeroStickyWidgetInputSchema(): z.ZodObject<Properties<CreateLgpHeroStickyWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    gpId: z.string(),
    info: z.lazy(() => LgpHeroStickyInfoInputSchema().nullish()),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
    session: z.lazy(() => LgpHeroStickySessionInputSchema().nullish()),
  });
}

export function CreateLgpHeroWidgetInputSchema(): z.ZodObject<Properties<CreateLgpHeroWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    gpId: z.string(),
    info: z.lazy(() => LgpHeroInfoInputSchema().nullish()),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
    session: z.lazy(() => LgpHeroSessionInputSchema().nullish()),
  });
}

export function CreateLgpPreviewWidgetInputSchema(): z.ZodObject<Properties<CreateLgpPreviewWidgetInput>> {
  return z.object({
    calendar: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    competitionId: z.string(),
    gpId: z.string(),
    gpName: z.string().nullish(),
    gpStartDateTime: z.string().nullish(),
    laps: z.string().nullish(),
    lengthKm: z.string().nullish(),
    news: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    ranking: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    results: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
    sessions: z.array(z.lazy(() => LgpPreviewSessionInputSchema().nullable())).nullish(),
    sportLabel: z.string().nullish(),
  });
}

export function CreateLgpResultsContainerWidgetInputSchema(): z.ZodObject<
  Properties<CreateLgpResultsContainerWidgetInput>
> {
  return z.object({
    FP1: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    FP2: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    FP3: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    FP4: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    G: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    GS: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    Q: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    QS: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    R: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    SPRINT: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    SS: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    competitionId: z.string(),
    gpId: z.string(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
  });
}

export function CreateLgpResultsWidgetInputSchema(): z.ZodObject<Properties<CreateLgpResultsWidgetInput>> {
  return z.object({
    calendar: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    competitionId: z.string(),
    gpId: z.string(),
    gpInfo: z.lazy(() => LgpResultsGpInfoInputSchema().nullish()),
    gpStatus: z.string().nullish(),
    isCurrent: z.boolean().nullish(),
    ranking: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    results: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
    sessionName: z.string(),
    sessions: z.array(z.lazy(() => LgpResultsSessionInputSchema().nullable())).nullish(),
  });
}

export function CreateLiveScoreWidgetInputSchema(): z.ZodObject<Properties<CreateLiveScoreWidgetInput>> {
  return z.object({
    currentDay: z.array(z.lazy(() => LiveScoreWidgetDayInputSchema().nullable())).nullish(),
    id: z.string().nullish(),
    nextDay: z.array(z.lazy(() => LiveScoreWidgetDayInputSchema().nullable())).nullish(),
    previousDay: z.array(z.lazy(() => LiveScoreWidgetDayInputSchema().nullable())).nullish(),
  });
}

export function CreateSeasonInputSchema(): z.ZodObject<Properties<CreateSeasonInput>> {
  return z.object({
    seasonId: z.string(),
    seasonJson: z.any(),
  });
}

export function CreateSeasonRankingGalleryWidgetInputSchema(): z.ZodObject<
  Properties<CreateSeasonRankingGalleryWidgetInput>
> {
  return z.object({
    competitionId: z.string(),
    competitionName: z.string().nullish(),
    competitionsSlugName: z.string().nullish(),
    drivers: z.array(z.lazy(() => SeasonDriverRankingInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
    teams: z.array(z.lazy(() => SeasonTeamRankingInputSchema().nullable())).nullish(),
  });
}

export function CreateSessionInputSchema(): z.ZodObject<Properties<CreateSessionInput>> {
  return z.object({
    date: z.string().datetime().nullish(),
    gpId: z.string(),
    isCurrent: z.boolean().nullish(),
    seasonAndCompId: z.string(),
    sessionId: z.string(),
    sessionJson: z.any().nullish(),
    status: z.string().nullish(),
  });
}

export function CreateTeamDriverPageWidgetInputSchema(): z.ZodObject<Properties<CreateTeamDriverPageWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
    teamList: z.array(z.lazy(() => TeamDriverTeamInputSchema().nullable())).nullish(),
  });
}

export function CreateTeamInputSchema(): z.ZodObject<Properties<CreateTeamInput>> {
  return z.object({
    editorialDataId: z.string(),
    seasonAndCompId: z.string(),
    teamId: z.string(),
    teamJson: z.any(),
  });
}

export function CreateTeamRankingWidgetInputSchema(): z.ZodObject<Properties<CreateTeamRankingWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    competitionLabel: z.string().nullish(),
    items: z.array(z.lazy(() => TeamRankingTeamInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string(),
  });
}

export function DeleteCardDriverRankingWidgetInputSchema(): z.ZodObject<
  Properties<DeleteCardDriverRankingWidgetInput>
> {
  return z.object({
    competitionId: z.string(),
  });
}

export function DeleteCardGpCalendarWidgetInputSchema(): z.ZodObject<Properties<DeleteCardGpCalendarWidgetInput>> {
  return z.object({
    competitionId: z.string(),
  });
}

export function DeleteCardGpResultsWidgetInputSchema(): z.ZodObject<Properties<DeleteCardGpResultsWidgetInput>> {
  return z.object({
    competitionId: z.string(),
  });
}

export function DeleteCardTeamRankingWidgetInputSchema(): z.ZodObject<Properties<DeleteCardTeamRankingWidgetInput>> {
  return z.object({
    competitionId: z.string(),
  });
}

export function DeleteCompetitionInputSchema(): z.ZodObject<Properties<DeleteCompetitionInput>> {
  return z.object({
    seasonAndCompId: z.string(),
  });
}

export function DeleteCrossLinkInputSchema(): z.ZodObject<Properties<DeleteCrossLinkInput>> {
  return z.object({
    gpId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function DeleteDriverInputSchema(): z.ZodObject<Properties<DeleteDriverInput>> {
  return z.object({
    driverId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function DeleteDriverRankingWidgetInputSchema(): z.ZodObject<Properties<DeleteDriverRankingWidgetInput>> {
  return z.object({
    seasonAndCompId: z.string(),
  });
}

export function DeleteEditorialDataInputSchema(): z.ZodObject<Properties<DeleteEditorialDataInput>> {
  return z.object({
    editorialDataId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function DeleteGpCalendarWidgetInputSchema(): z.ZodObject<Properties<DeleteGpCalendarWidgetInput>> {
  return z.object({
    seasonAndCompId: z.string(),
  });
}

export function DeleteGpCurrentCalendarWidgetInputSchema(): z.ZodObject<
  Properties<DeleteGpCurrentCalendarWidgetInput>
> {
  return z.object({
    seasonAndCompId: z.string(),
  });
}

export function DeleteGpDataInputSchema(): z.ZodObject<Properties<DeleteGpDataInput>> {
  return z.object({
    gpId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function DeleteGpLiveContainerWidgetInputSchema(): z.ZodObject<Properties<DeleteGpLiveContainerWidgetInput>> {
  return z.object({
    seasonAndCompId: z.string(),
  });
}

export function DeleteGpLiveHeroWidgetInputSchema(): z.ZodObject<Properties<DeleteGpLiveHeroWidgetInput>> {
  return z.object({
    seasonAndCompId: z.string(),
  });
}

export function DeleteGpPodiumListWidgetInputSchema(): z.ZodObject<Properties<DeleteGpPodiumListWidgetInput>> {
  return z.object({
    seasonAndCompId: z.string(),
  });
}

export function DeleteGpResultsContainerWidgetInputSchema(): z.ZodObject<
  Properties<DeleteGpResultsContainerWidgetInput>
> {
  return z.object({
    gpId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function DeleteGpResultsWidgetInputSchema(): z.ZodObject<Properties<DeleteGpResultsWidgetInput>> {
  return z.object({
    gpId: z.string(),
    sessionName: z.string(),
  });
}

export function DeleteGrandPrixInputSchema(): z.ZodObject<Properties<DeleteGrandPrixInput>> {
  return z.object({
    gpId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function DeleteLgpHeroStickyWidgetInputSchema(): z.ZodObject<Properties<DeleteLgpHeroStickyWidgetInput>> {
  return z.object({
    gpId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function DeleteLgpHeroWidgetInputSchema(): z.ZodObject<Properties<DeleteLgpHeroWidgetInput>> {
  return z.object({
    gpId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function DeleteLgpPreviewWidgetInputSchema(): z.ZodObject<Properties<DeleteLgpPreviewWidgetInput>> {
  return z.object({
    gpId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function DeleteLgpResultsContainerWidgetInputSchema(): z.ZodObject<
  Properties<DeleteLgpResultsContainerWidgetInput>
> {
  return z.object({
    gpId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function DeleteLgpResultsWidgetInputSchema(): z.ZodObject<Properties<DeleteLgpResultsWidgetInput>> {
  return z.object({
    gpId: z.string(),
    sessionName: z.string(),
  });
}

export function DeleteLiveScoreWidgetInputSchema(): z.ZodObject<Properties<DeleteLiveScoreWidgetInput>> {
  return z.object({
    id: z.string(),
  });
}

export function DeleteSeasonInputSchema(): z.ZodObject<Properties<DeleteSeasonInput>> {
  return z.object({
    seasonId: z.string(),
  });
}

export function DeleteSeasonRankingGalleryWidgetInputSchema(): z.ZodObject<
  Properties<DeleteSeasonRankingGalleryWidgetInput>
> {
  return z.object({
    seasonAndCompId: z.string(),
  });
}

export function DeleteSessionInputSchema(): z.ZodObject<Properties<DeleteSessionInput>> {
  return z.object({
    gpId: z.string(),
    sessionId: z.string(),
  });
}

export function DeleteTeamDriverPageWidgetInputSchema(): z.ZodObject<Properties<DeleteTeamDriverPageWidgetInput>> {
  return z.object({
    seasonAndCompId: z.string(),
  });
}

export function DeleteTeamInputSchema(): z.ZodObject<Properties<DeleteTeamInput>> {
  return z.object({
    seasonAndCompId: z.string(),
    teamId: z.string(),
  });
}

export function DeleteTeamRankingWidgetInputSchema(): z.ZodObject<Properties<DeleteTeamRankingWidgetInput>> {
  return z.object({
    seasonAndCompId: z.string(),
  });
}

export function DriverRankingDriverInfoInputSchema(): z.ZodObject<Properties<DriverRankingDriverInfoInput>> {
  return z.object({
    customDriverName: z.string().nullish(),
    customDriverPageUrl: z.string().nullish(),
    customDriverSurname: z.string().nullish(),
    customTeamName: z.string().nullish(),
    customTeamPageUrl: z.string().nullish(),
    firstName: z.string().nullish(),
    flagUrl: z.string().nullish(),
    lastName: z.string().nullish(),
    nationality: z.string().nullish(),
    pos: z.string().nullish(),
    pts: z.string().nullish(),
  });
}

export function DriverRankingDriverInputSchema(): z.ZodObject<Properties<DriverRankingDriverInput>> {
  return z.object({
    driverInfo: z.lazy(() => DriverRankingDriverInfoInputSchema().nullish()),
  });
}

export function GpCalendarGpInfoInputSchema(): z.ZodObject<Properties<GpCalendarGpInfoInput>> {
  return z.object({
    circuitUrl: z.string().nullish(),
    customGpName: z.string().nullish(),
    flagUrl: z.string().nullish(),
    gpCrosslink: z.string().nullish(),
    gpPageUrl: z.string().nullish(),
    gpStatus: z.string().nullish(),
    isCurrent: z.boolean().nullish(),
    isExclusive: z.boolean().nullish(),
    isSprint: z.boolean().nullish(),
    lapRecord: z.string().nullish(),
    laps: z.string().nullish(),
    lengthKm: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function GpCalendarItemInputSchema(): z.ZodObject<Properties<GpCalendarItemInput>> {
  return z.object({
    gpInfo: z.lazy(() => GpCalendarGpInfoInputSchema().nullish()),
    isCurrent: z.boolean().nullish(),
    sessions: z.lazy(() => GpCalendarItemSessionsInputSchema().nullish()),
  });
}

export function GpCalendarItemSessionsInputSchema(): z.ZodObject<Properties<GpCalendarItemSessionsInput>> {
  return z.object({
    items: z.array(z.lazy(() => GpCalendarSessionInputSchema().nullable())).nullish(),
  });
}

export function GpCalendarSessionInfoInputSchema(): z.ZodObject<Properties<GpCalendarSessionInfoInput>> {
  return z.object({
    isCurrent: z.boolean().nullish(),
    sessionLabel: z.string().nullish(),
    sessionName: z.string().nullish(),
    sessionStatus: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function GpCalendarSessionInputSchema(): z.ZodObject<Properties<GpCalendarSessionInput>> {
  return z.object({
    isCurrent: z.boolean().nullish(),
    sessionInfo: z.lazy(() => GpCalendarSessionInfoInputSchema().nullish()),
    sessionLabel: z.string().nullish(),
    sessionResultUrl: z.string().nullish(),
    sessionStatus: z.string().nullish(),
  });
}

export function GpLiveContainerWrapperAttributesInputSchema(): z.ZodObject<
  Properties<GpLiveContainerWrapperAttributesInput>
> {
  return z.object({
    tracking: z.string().nullish(),
    url: z.string().nullish(),
  });
}

export function GpLiveContainerWrapperInputSchema(): z.ZodObject<Properties<GpLiveContainerWrapperInput>> {
  return z.object({
    customDataAttributes: z.lazy(() => GpLiveContainerWrapperAttributesInputSchema().nullish()),
    isActive: z.boolean().nullish(),
    ssi: z.string().nullish(),
    type: z.string().nullish(),
  });
}

export function GpLiveHeroGpInfoInputSchema(): z.ZodObject<Properties<GpLiveHeroGpInfoInput>> {
  return z.object({
    circuitUrl: z.string().nullish(),
    customGpName: z.string().nullish(),
    flagUrl: z.string().nullish(),
    gpPageUrl: z.string().nullish(),
    gpStatus: z.string().nullish(),
    isCurrent: z.boolean().nullish(),
    isExclusive: z.boolean().nullish(),
    isSprint: z.boolean().nullish(),
    lapRecord: z.string().nullish(),
    laps: z.string().nullish(),
    lengthKm: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function GpPodiumListGpInfoInputSchema(): z.ZodObject<Properties<GpPodiumListGpInfoInput>> {
  return z.object({
    customGpName: z.string().nullish(),
    gpCrosslink: z.string().nullish(),
    gpPageUrl: z.string().nullish(),
    gpStatus: z.string().nullish(),
    isCurrent: z.boolean().nullish(),
    isExclusive: z.boolean().nullish(),
    isSprint: z.boolean().nullish(),
    lapRecord: z.string().nullish(),
    laps: z.string().nullish(),
    lengthKm: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function GpPodiumListGrandPrixInputSchema(): z.ZodObject<Properties<GpPodiumListGrandPrixInput>> {
  return z.object({
    gpInfo: z.lazy(() => GpPodiumListGpInfoInputSchema().nullish()),
    gpStatus: z.string().nullish(),
    isCurrent: z.boolean().nullish(),
    session: z.lazy(() => GpPodiumListSessionInputSchema().nullish()),
  });
}

export function GpPodiumListSessionInfoDetailsInputSchema(): z.ZodObject<
  Properties<GpPodiumListSessionInfoDetailsInput>
> {
  return z.object({
    customDriverName: z.string().nullish(),
    customDriverPageUrl: z.string().nullish(),
    customDriverSurname: z.string().nullish(),
    customTeamName: z.string().nullish(),
    customTeamPageUrl: z.string().nullish(),
    fastestLap: z.string().nullish(),
    firstName: z.string().nullish(),
    flagUrl: z.string().nullish(),
    gap: z.string().nullish(),
    isFastestLap: z.boolean().nullish(),
    laps: z.string().nullish(),
    lastName: z.string().nullish(),
    points: z.lazy(() => GpPodiumListSessionInfoDetailsPointsInputSchema().nullish()),
    position: z.string().nullish(),
    status: z.string().nullish(),
    team: z.lazy(() => GpPodiumListSessionInfoDetailsTeamInputSchema().nullish()),
    timing: z.lazy(() => GpPodiumListSessionInfoDetailsTimingInputSchema().nullish()),
  });
}

export function GpPodiumListSessionInfoDetailsPointsInputSchema(): z.ZodObject<
  Properties<GpPodiumListSessionInfoDetailsPointsInput>
> {
  return z.object({
    personPoints: z.string().nullish(),
    teamPoints: z.string().nullish(),
  });
}

export function GpPodiumListSessionInfoDetailsTeamInputSchema(): z.ZodObject<
  Properties<GpPodiumListSessionInfoDetailsTeamInput>
> {
  return z.object({
    name: z.string().nullish(),
  });
}

export function GpPodiumListSessionInfoDetailsTimingInputSchema(): z.ZodObject<
  Properties<GpPodiumListSessionInfoDetailsTimingInput>
> {
  return z.object({
    timeHours: z.string().nullish(),
    timeMilliseconds: z.string().nullish(),
    timeMinutes: z.string().nullish(),
    timeSeconds: z.string().nullish(),
  });
}

export function GpPodiumListSessionInfoInputSchema(): z.ZodObject<Properties<GpPodiumListSessionInfoInput>> {
  return z.object({
    details: z.array(z.lazy(() => GpPodiumListSessionInfoDetailsInputSchema().nullable())).nullish(),
    isCurrent: z.boolean().nullish(),
    sessionLabel: z.string().nullish(),
    sessionName: z.string().nullish(),
    sessionStatus: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function GpPodiumListSessionInputSchema(): z.ZodObject<Properties<GpPodiumListSessionInput>> {
  return z.object({
    isCurrent: z.boolean().nullish(),
    sessionInfo: z.lazy(() => GpPodiumListSessionInfoInputSchema().nullish()),
    sessionLabel: z.string().nullish(),
    sessionStatus: z.string().nullish(),
  });
}

export function GpResultsContainerWrapperAttributesInputSchema(): z.ZodObject<
  Properties<GpResultsContainerWrapperAttributesInput>
> {
  return z.object({
    tracking: z.string().nullish(),
    url: z.string().nullish(),
  });
}

export function GpResultsContainerWrapperInputSchema(): z.ZodObject<Properties<GpResultsContainerWrapperInput>> {
  return z.object({
    customDataAttributes: z.lazy(() => GpResultsContainerWrapperAttributesInputSchema().nullish()),
    ssi: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function GpResultsGpInfoInputSchema(): z.ZodObject<Properties<GpResultsGpInfoInput>> {
  return z.object({
    customGpName: z.string().nullish(),
    gpStatus: z.string().nullish(),
    isCurrent: z.boolean().nullish(),
    isExclusive: z.boolean().nullish(),
    isSprint: z.boolean().nullish(),
    lapRecord: z.string().nullish(),
    laps: z.string().nullish(),
    lengthKm: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function GpResultsSessionInfoDetailsInputSchema(): z.ZodObject<Properties<GpResultsSessionInfoDetailsInput>> {
  return z.object({
    customDriverName: z.string().nullish(),
    customDriverPageUrl: z.string().nullish(),
    customDriverSurname: z.string().nullish(),
    customTeamName: z.string().nullish(),
    customTeamPageUrl: z.string().nullish(),
    fastestLap: z.string().nullish(),
    firstName: z.string().nullish(),
    flagUrl: z.string().nullish(),
    gap: z.string().nullish(),
    isFastestLap: z.boolean().nullish(),
    laps: z.string().nullish(),
    lastName: z.string().nullish(),
    points: z.lazy(() => GpResultsSessionInfoDetailsPointsInputSchema().nullish()),
    position: z.string().nullish(),
    status: z.string().nullish(),
    team: z.lazy(() => GpResultsSessionInfoDetailsTeamInputSchema().nullish()),
    timing: z.lazy(() => GpResultsSessionInfoDetailsTimingInputSchema().nullish()),
  });
}

export function GpResultsSessionInfoDetailsPointsInputSchema(): z.ZodObject<
  Properties<GpResultsSessionInfoDetailsPointsInput>
> {
  return z.object({
    personPoints: z.string().nullish(),
    teamPoints: z.string().nullish(),
  });
}

export function GpResultsSessionInfoDetailsTeamInputSchema(): z.ZodObject<
  Properties<GpResultsSessionInfoDetailsTeamInput>
> {
  return z.object({
    name: z.string().nullish(),
  });
}

export function GpResultsSessionInfoDetailsTimingInputSchema(): z.ZodObject<
  Properties<GpResultsSessionInfoDetailsTimingInput>
> {
  return z.object({
    timeHours: z.string().nullish(),
    timeMilliseconds: z.string().nullish(),
    timeMinutes: z.string().nullish(),
    timeSeconds: z.string().nullish(),
  });
}

export function GpResultsSessionInfoInputSchema(): z.ZodObject<Properties<GpResultsSessionInfoInput>> {
  return z.object({
    details: z.array(z.lazy(() => GpResultsSessionInfoDetailsInputSchema().nullable())).nullish(),
    isCurrent: z.boolean().nullish(),
    sessionLabel: z.string().nullish(),
    sessionName: z.string().nullish(),
    sessionStatus: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function GpResultsSessionInputSchema(): z.ZodObject<Properties<GpResultsSessionInput>> {
  return z.object({
    isCurrent: z.boolean().nullish(),
    sessionInfo: z.lazy(() => GpResultsSessionInfoInputSchema().nullish()),
  });
}

export function LgpHeroInfoInputSchema(): z.ZodObject<Properties<LgpHeroInfoInput>> {
  return z.object({
    circuitImgUrl: z.string().nullish(),
    customGpName: z.string().nullish(),
    endDate: z.string().nullish(),
    flagImgUrl: z.string().nullish(),
    sportTag: z.string().nullish(),
    startDate: z.string().nullish(),
  });
}

export function LgpHeroPodiumInputSchema(): z.ZodObject<Properties<LgpHeroPodiumInput>> {
  return z.object({
    customDriverName: z.string().nullish(),
    customDriverShortName: z.string().nullish(),
    customDriverSurname: z.string().nullish(),
    driverImgUrl: z.string().nullish(),
    flagImgUrl: z.string().nullish(),
    position: z.number().nullish(),
  });
}

export function LgpHeroSessionInputSchema(): z.ZodObject<Properties<LgpHeroSessionInput>> {
  return z.object({
    date: z.string().nullish(),
    label: z.string().nullish(),
    name: z.string().nullish(),
    podium: z.array(z.lazy(() => LgpHeroPodiumInputSchema())).nullish(),
    status: z.string().nullish(),
  });
}

export function LgpHeroStickyInfoInputSchema(): z.ZodObject<Properties<LgpHeroStickyInfoInput>> {
  return z.object({
    customGpName: z.string().nullish(),
    endDate: z.string().nullish(),
    flagImgUrl: z.string().nullish(),
    startDate: z.string().nullish(),
  });
}

export function LgpHeroStickySessionInputSchema(): z.ZodObject<Properties<LgpHeroStickySessionInput>> {
  return z.object({
    label: z.string().nullish(),
    name: z.string().nullish(),
    status: z.string().nullish(),
  });
}

export function LgpInfoLinkInputSchema(): z.ZodObject<Properties<LgpInfoLinkInput>> {
  return z.object({
    link: z.string().nullish(),
    text: z.string().nullish(),
  });
}

export function LgpPreviewSessionInputSchema(): z.ZodObject<Properties<LgpPreviewSessionInput>> {
  return z.object({
    date: z.string().nullish(),
    sessionName: z.string().nullish(),
  });
}

export function LgpResultsContainerWrapperAttributesInputSchema(): z.ZodObject<
  Properties<LgpResultsContainerWrapperAttributesInput>
> {
  return z.object({
    tracking: z.string().nullish(),
    url: z.string().nullish(),
  });
}

export function LgpResultsContainerWrapperInputSchema(): z.ZodObject<Properties<LgpResultsContainerWrapperInput>> {
  return z.object({
    customDataAttributes: z.lazy(() => LgpResultsContainerWrapperAttributesInputSchema().nullish()),
    ssi: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function LgpResultsGpInfoInputSchema(): z.ZodObject<Properties<LgpResultsGpInfoInput>> {
  return z.object({
    customGpName: z.string().nullish(),
    gpStatus: z.string().nullish(),
    isCurrent: z.boolean().nullish(),
    isExclusive: z.boolean().nullish(),
    isSprint: z.boolean().nullish(),
    lapRecord: z.string().nullish(),
    laps: z.string().nullish(),
    lengthKm: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function LgpResultsSessionInfoDetailsInputSchema(): z.ZodObject<Properties<LgpResultsSessionInfoDetailsInput>> {
  return z.object({
    customDriverName: z.string().nullish(),
    customDriverPageUrl: z.string().nullish(),
    customDriverSurname: z.string().nullish(),
    customTeamName: z.string().nullish(),
    customTeamPageUrl: z.string().nullish(),
    fastestLap: z.string().nullish(),
    flagUrl: z.string().nullish(),
    gap: z.string().nullish(),
    isFastestLap: z.boolean().nullish(),
    laps: z.string().nullish(),
    position: z.string().nullish(),
    status: z.string().nullish(),
    timing: z.lazy(() => LgpResultsSessionInfoDetailsTimingInputSchema().nullish()),
  });
}

export function LgpResultsSessionInfoDetailsTimingInputSchema(): z.ZodObject<
  Properties<LgpResultsSessionInfoDetailsTimingInput>
> {
  return z.object({
    timeHours: z.string().nullish(),
    timeMilliseconds: z.string().nullish(),
    timeMinutes: z.string().nullish(),
    timeSeconds: z.string().nullish(),
  });
}

export function LgpResultsSessionInfoInputSchema(): z.ZodObject<Properties<LgpResultsSessionInfoInput>> {
  return z.object({
    details: z.array(z.lazy(() => LgpResultsSessionInfoDetailsInputSchema().nullable())).nullish(),
    isCurrent: z.boolean().nullish(),
    sessionLabel: z.string().nullish(),
    sessionName: z.string().nullish(),
    sessionStatus: z.string().nullish(),
    startDateTime: z.string().nullish(),
  });
}

export function LgpResultsSessionInputSchema(): z.ZodObject<Properties<LgpResultsSessionInput>> {
  return z.object({
    isCurrent: z.boolean().nullish(),
    sessionInfo: z.lazy(() => LgpResultsSessionInfoInputSchema().nullish()),
  });
}

export function LiveScoreWidgetDayInputSchema(): z.ZodObject<Properties<LiveScoreWidgetDayInput>> {
  return z.object({
    gpInfo: z.lazy(() => LiveScoreWidgetGpInfoInputSchema().nullish()),
    sessions: z.array(z.lazy(() => LiveScoreWidgetSessionInputSchema().nullable())).nullish(),
    sportTag: z.string().nullish(),
  });
}

export function LiveScoreWidgetGpInfoInputSchema(): z.ZodObject<Properties<LiveScoreWidgetGpInfoInput>> {
  return z.object({
    calendarUrl: z.string().nullish(),
    customGpName: z.string().nullish(),
    gpCrosslink: z.string().nullish(),
    gpFlag: z.string().nullish(),
    gpPageUrl: z.string().nullish(),
    rankingUrl: z.string().nullish(),
  });
}

export function LiveScoreWidgetResultsInputSchema(): z.ZodObject<Properties<LiveScoreWidgetResultsInput>> {
  return z.object({
    customDriverName: z.string().nullish(),
    customDriverPageUrl: z.string().nullish(),
    customDriverSurname: z.string().nullish(),
    customTeamName: z.string().nullish(),
    customTeamPageUrl: z.string().nullish(),
    fastestLap: z.string().nullish(),
    firstName: z.string().nullish(),
    flagUrl: z.string().nullish(),
    gap: z.string().nullish(),
    isFastestLap: z.boolean().nullish(),
    lastName: z.string().nullish(),
    position: z.string().nullish(),
    teamName: z.string().nullish(),
    timing: z.lazy(() => LiveScoreWidgetResultsTimingInputSchema().nullish()),
  });
}

export function LiveScoreWidgetResultsTimingInputSchema(): z.ZodObject<Properties<LiveScoreWidgetResultsTimingInput>> {
  return z.object({
    timeHours: z.string().nullish(),
    timeMilliseconds: z.string().nullish(),
    timeMinutes: z.string().nullish(),
    timeSeconds: z.string().nullish(),
  });
}

export function LiveScoreWidgetSessionInputSchema(): z.ZodObject<Properties<LiveScoreWidgetSessionInput>> {
  return z.object({
    results: z.array(z.lazy(() => LiveScoreWidgetResultsInputSchema().nullable())).nullish(),
    resultsUrl: z.string().nullish(),
    sessionDate: z.string().nullish(),
    sessionName: z.string().nullish(),
    sessionStatus: z.string().nullish(),
  });
}

export function ModelBooleanFilterInputSchema(): z.ZodObject<Properties<ModelBooleanFilterInput>> {
  return z.object({
    eq: z.boolean().nullish(),
    ne: z.boolean().nullish(),
  });
}

export function ModelCardDriverRankingWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelCardDriverRankingWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelCardDriverRankingWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    customCompetitionName: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    not: z.lazy(() => ModelCardDriverRankingWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelCardDriverRankingWidgetFilterInputSchema().nullable())).nullish(),
    rankingLink: z.lazy(() => ModelStringFilterInputSchema().nullish()),
  });
}

export function ModelCardGpCalendarWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelCardGpCalendarWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelCardGpCalendarWidgetFilterInputSchema().nullable())).nullish(),
    calendarLink: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    customCompetitionName: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    not: z.lazy(() => ModelCardGpCalendarWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelCardGpCalendarWidgetFilterInputSchema().nullable())).nullish(),
  });
}

export function ModelCardGpResultsWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelCardGpResultsWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelCardGpResultsWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    customCompetitionName: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    customGpName: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    isSprint: z.lazy(() => ModelBooleanFilterInputSchema().nullish()),
    not: z.lazy(() => ModelCardGpResultsWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelCardGpResultsWidgetFilterInputSchema().nullable())).nullish(),
    resultsLink: z.lazy(() => ModelStringFilterInputSchema().nullish()),
  });
}

export function ModelCardTeamRankingWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelCardTeamRankingWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelCardTeamRankingWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    customCompetitionName: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    not: z.lazy(() => ModelCardTeamRankingWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelCardTeamRankingWidgetFilterInputSchema().nullable())).nullish(),
    rankingLink: z.lazy(() => ModelStringFilterInputSchema().nullish()),
  });
}

export function ModelCompetitionFilterInputSchema(): z.ZodObject<Properties<ModelCompetitionFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelCompetitionFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    competitionJson: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    editorialDataId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelCompetitionFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelCompetitionFilterInputSchema().nullable())).nullish(),
    previousSeasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelCrossLinkFilterInputSchema(): z.ZodObject<Properties<ModelCrossLinkFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelCrossLinkFilterInputSchema().nullable())).nullish(),
    crossLinkJson: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    gpId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelCrossLinkFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelCrossLinkFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelDriverFilterInputSchema(): z.ZodObject<Properties<ModelDriverFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelDriverFilterInputSchema().nullable())).nullish(),
    driverId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    driverJson: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    editorialDataId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelDriverFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelDriverFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    teamId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelDriverRankingWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelDriverRankingWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelDriverRankingWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    competitionLabel: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    not: z.lazy(() => ModelDriverRankingWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelDriverRankingWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelEditorialDataFilterInputSchema(): z.ZodObject<Properties<ModelEditorialDataFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelEditorialDataFilterInputSchema().nullable())).nullish(),
    editorialDataId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    editorialJson: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    isCurrent: z.lazy(() => ModelBooleanFilterInputSchema().nullish()),
    not: z.lazy(() => ModelEditorialDataFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelEditorialDataFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelFloatFilterInputSchema(): z.ZodObject<Properties<ModelFloatFilterInput>> {
  return z.object({
    between: z.array(z.number().nullable()).nullish(),
    eq: z.number().nullish(),
    ge: z.number().nullish(),
    gt: z.number().nullish(),
    le: z.number().nullish(),
    lt: z.number().nullish(),
    ne: z.number().nullish(),
  });
}

export function ModelGpCalendarWidgetFilterInputSchema(): z.ZodObject<Properties<ModelGpCalendarWidgetFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelGpCalendarWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelGpCalendarWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelGpCalendarWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelGpCurrentCalendarWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelGpCurrentCalendarWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelGpCurrentCalendarWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelGpCurrentCalendarWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelGpCurrentCalendarWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelGpDataFilterInputSchema(): z.ZodObject<Properties<ModelGpDataFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelGpDataFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    data: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    gpId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    messageType: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    not: z.lazy(() => ModelGpDataFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelGpDataFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelGpLiveContainerWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelGpLiveContainerWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelGpLiveContainerWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelGpLiveContainerWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelGpLiveContainerWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelGpLiveHeroWidgetFilterInputSchema(): z.ZodObject<Properties<ModelGpLiveHeroWidgetFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelGpLiveHeroWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    isCurrent: z.lazy(() => ModelBooleanFilterInputSchema().nullish()),
    not: z.lazy(() => ModelGpLiveHeroWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelGpLiveHeroWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelGpPodiumListWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelGpPodiumListWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelGpPodiumListWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelGpPodiumListWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelGpPodiumListWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelGpResultsContainerWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelGpResultsContainerWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelGpResultsContainerWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelGpResultsContainerWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelGpResultsContainerWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelGpResultsWidgetFilterInputSchema(): z.ZodObject<Properties<ModelGpResultsWidgetFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelGpResultsWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpStatus: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    isCurrent: z.lazy(() => ModelBooleanFilterInputSchema().nullish()),
    not: z.lazy(() => ModelGpResultsWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelGpResultsWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    sessionName: z.lazy(() => ModelStringFilterInputSchema().nullish()),
  });
}

export function ModelGrandPrixFilterInputSchema(): z.ZodObject<Properties<ModelGrandPrixFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelGrandPrixFilterInputSchema().nullable())).nullish(),
    date: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    editorialDataId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpJson: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    isCurrent: z.lazy(() => ModelBooleanFilterInputSchema().nullish()),
    not: z.lazy(() => ModelGrandPrixFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelGrandPrixFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    status: z.lazy(() => ModelStringFilterInputSchema().nullish()),
  });
}

export function ModelIdFilterInputSchema(): z.ZodObject<Properties<ModelIntFilterInput>> {
  return z.object({
    beginsWith: z.string().nullish(),
    between: z.array(z.string().nullable()).nullish(),
    contains: z.string().nullish(),
    eq: z.string().nullish(),
    ge: z.string().nullish(),
    gt: z.string().nullish(),
    le: z.string().nullish(),
    lt: z.string().nullish(),
    ne: z.string().nullish(),
    notContains: z.string().nullish(),
  });
}

export function ModelIdKeyConditionInputSchema(): z.ZodObject<Properties<ModelStringKeyConditionInput>> {
  return z.object({
    beginsWith: z.string().nullish(),
    between: z.array(z.string().nullable()).nullish(),
    eq: z.string().nullish(),
    ge: z.string().nullish(),
    gt: z.string().nullish(),
    le: z.string().nullish(),
    lt: z.string().nullish(),
  });
}

export function ModelIntFilterInputSchema(): z.ZodObject<Properties<ModelIntFilterInput>> {
  return z.object({
    between: z.array(z.number().nullable()).nullish(),
    eq: z.number().nullish(),
    ge: z.number().nullish(),
    gt: z.number().nullish(),
    le: z.number().nullish(),
    lt: z.number().nullish(),
    ne: z.number().nullish(),
  });
}

export function ModelLgpHeroStickyWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelLgpHeroStickyWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelLgpHeroStickyWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelLgpHeroStickyWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelLgpHeroStickyWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelLgpHeroWidgetFilterInputSchema(): z.ZodObject<Properties<ModelLgpHeroWidgetFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelLgpHeroWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelLgpHeroWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelLgpHeroWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelLgpPreviewWidgetFilterInputSchema(): z.ZodObject<Properties<ModelLgpPreviewWidgetFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelLgpPreviewWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpName: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    gpStartDateTime: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    laps: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    lengthKm: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    not: z.lazy(() => ModelLgpPreviewWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelLgpPreviewWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    sportLabel: z.lazy(() => ModelStringFilterInputSchema().nullish()),
  });
}

export function ModelLgpResultsContainerWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelLgpResultsContainerWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelLgpResultsContainerWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelLgpResultsContainerWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelLgpResultsContainerWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelLgpResultsWidgetFilterInputSchema(): z.ZodObject<Properties<ModelLgpResultsWidgetFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelLgpResultsWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    gpStatus: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    isCurrent: z.lazy(() => ModelBooleanFilterInputSchema().nullish()),
    not: z.lazy(() => ModelLgpResultsWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelLgpResultsWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    sessionName: z.lazy(() => ModelStringFilterInputSchema().nullish()),
  });
}

export function ModelLiveScoreWidgetFilterInputSchema(): z.ZodObject<Properties<ModelLiveScoreWidgetFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelLiveScoreWidgetFilterInputSchema().nullable())).nullish(),
    id: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelLiveScoreWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelLiveScoreWidgetFilterInputSchema().nullable())).nullish(),
  });
}

export function ModelSeasonFilterInputSchema(): z.ZodObject<Properties<ModelSeasonFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelSeasonFilterInputSchema().nullable())).nullish(),
    not: z.lazy(() => ModelSeasonFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelSeasonFilterInputSchema().nullable())).nullish(),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonJson: z.lazy(() => ModelStringFilterInputSchema().nullish()),
  });
}

export function ModelSeasonRankingGalleryWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelSeasonRankingGalleryWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelSeasonRankingGalleryWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    competitionName: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    competitionsSlugName: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    not: z.lazy(() => ModelSeasonRankingGalleryWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelSeasonRankingGalleryWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelSessionFilterInputSchema(): z.ZodObject<Properties<ModelSessionFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelSessionFilterInputSchema().nullable())).nullish(),
    date: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    gpId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    isCurrent: z.lazy(() => ModelBooleanFilterInputSchema().nullish()),
    not: z.lazy(() => ModelSessionFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelSessionFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    sessionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    sessionJson: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    status: z.lazy(() => ModelStringFilterInputSchema().nullish()),
  });
}

export function ModelStringFilterInputSchema(): z.ZodObject<Properties<ModelStringFilterInput>> {
  return z.object({
    beginsWith: z.string().nullish(),
    between: z.array(z.string().nullable()).nullish(),
    contains: z.string().nullish(),
    eq: z.string().nullish(),
    ge: z.string().nullish(),
    gt: z.string().nullish(),
    le: z.string().nullish(),
    lt: z.string().nullish(),
    ne: z.string().nullish(),
    notContains: z.string().nullish(),
  });
}

export function ModelStringKeyConditionInputSchema(): z.ZodObject<Properties<ModelStringKeyConditionInput>> {
  return z.object({
    beginsWith: z.string().nullish(),
    between: z.array(z.string().nullable()).nullish(),
    eq: z.string().nullish(),
    ge: z.string().nullish(),
    gt: z.string().nullish(),
    le: z.string().nullish(),
    lt: z.string().nullish(),
  });
}

export function ModelTeamDriverPageWidgetFilterInputSchema(): z.ZodObject<
  Properties<ModelTeamDriverPageWidgetFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ModelTeamDriverPageWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelTeamDriverPageWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelTeamDriverPageWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function ModelTeamFilterInputSchema(): z.ZodObject<Properties<ModelTeamFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelTeamFilterInputSchema().nullable())).nullish(),
    editorialDataId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    not: z.lazy(() => ModelTeamFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelTeamFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    teamId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    teamJson: z.lazy(() => ModelStringFilterInputSchema().nullish()),
  });
}

export function ModelTeamRankingWidgetFilterInputSchema(): z.ZodObject<Properties<ModelTeamRankingWidgetFilterInput>> {
  return z.object({
    and: z.array(z.lazy(() => ModelTeamRankingWidgetFilterInputSchema().nullable())).nullish(),
    competitionId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    competitionLabel: z.lazy(() => ModelStringFilterInputSchema().nullish()),
    not: z.lazy(() => ModelTeamRankingWidgetFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ModelTeamRankingWidgetFilterInputSchema().nullable())).nullish(),
    seasonAndCompId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
    seasonId: z.lazy(() => ModelIdFilterInputSchema().nullish()),
  });
}

export function S3ObjectSchema(): z.ZodObject<Properties<S3Object>> {
  return z.object({
    content: z.string().nullish(),
    key: z.string().nullish(),
  });
}

export function SeasonDriverRankingInputSchema(): z.ZodObject<Properties<SeasonDriverRankingInput>> {
  return z.object({
    driverFirstname: z.string().nullish(),
    driverId: z.string(),
    driverImageUrl: z.string().nullish(),
    driverPageLink: z.string().nullish(),
    driverSurname: z.string().nullish(),
    logoUrl: z.string().nullish(),
    points: z.string().nullish(),
    position: z.string().nullish(),
    teamId: z.string(),
    teamName: z.string().nullish(),
    teamUrl: z.string().nullish(),
  });
}

export function SeasonTeamRankingInputSchema(): z.ZodObject<Properties<SeasonTeamRankingInput>> {
  return z.object({
    logoUrl: z.string().nullish(),
    points: z.string().nullish(),
    position: z.string().nullish(),
    teamId: z.string(),
    teamImageUrl: z.string().nullish(),
    teamName: z.string().nullish(),
    teamUrl: z.string().nullish(),
  });
}

export function TeamDriverDriverInputSchema(): z.ZodObject<Properties<TeamDriverDriverInput>> {
  return z.object({
    imageUrl: z.string().nullish(),
    name: z.string().nullish(),
    position: z.number().nullish(),
    url: z.string().nullish(),
  });
}

export function TeamDriverTeamInputSchema(): z.ZodObject<Properties<TeamDriverTeamInput>> {
  return z.object({
    drivers: z.array(z.lazy(() => TeamDriverDriverInputSchema().nullable())).nullish(),
    position: z.number().nullish(),
    teamLogoUrl: z.string().nullish(),
    teamName: z.string().nullish(),
    teamUrl: z.string().nullish(),
  });
}

export function TeamRankingTeamInputSchema(): z.ZodObject<Properties<TeamRankingTeamInput>> {
  return z.object({
    customTeamPageUrl: z.string().nullish(),
    pos: z.string().nullish(),
    pts: z.string().nullish(),
    teamName: z.string().nullish(),
  });
}

export function UpdateCardDriverRankingWidgetInputSchema(): z.ZodObject<
  Properties<UpdateCardDriverRankingWidgetInput>
> {
  return z.object({
    competitionId: z.string(),
    customCompetitionName: z.string().nullish(),
    drivers: z.array(z.lazy(() => CardDriverRankingDriverInfoInputSchema().nullable())).nullish(),
    rankingLink: z.string().nullish(),
  });
}

export function UpdateCardGpCalendarWidgetInputSchema(): z.ZodObject<Properties<UpdateCardGpCalendarWidgetInput>> {
  return z.object({
    calendarLink: z.string().nullish(),
    competitionId: z.string(),
    customCompetitionName: z.string().nullish(),
    gpList: z.array(z.lazy(() => CardGpCalendarGpInfoInputSchema().nullable())).nullish(),
  });
}

export function UpdateCardGpResultsWidgetInputSchema(): z.ZodObject<Properties<UpdateCardGpResultsWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    customCompetitionName: z.string().nullish(),
    customGpName: z.string().nullish(),
    isSprint: z.boolean().nullish(),
    results: z.array(z.lazy(() => CardGpResultsResultInfoInputSchema().nullable())).nullish(),
    resultsLink: z.string().nullish(),
  });
}

export function UpdateCardTeamRankingWidgetInputSchema(): z.ZodObject<Properties<UpdateCardTeamRankingWidgetInput>> {
  return z.object({
    competitionId: z.string(),
    customCompetitionName: z.string().nullish(),
    rankingLink: z.string().nullish(),
    teams: z.array(z.lazy(() => CardTeamRankingTeamInfoInputSchema().nullable())).nullish(),
  });
}

export function UpdateCompetitionInputSchema(): z.ZodObject<Properties<UpdateCompetitionInput>> {
  return z.object({
    competitionId: z.string().nullish(),
    competitionJson: z.any().nullish(),
    editorialDataId: z.string().nullish(),
    previousSeasonAndCompId: z.string().nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
  });
}

export function UpdateCrossLinkInputSchema(): z.ZodObject<Properties<UpdateCrossLinkInput>> {
  return z.object({
    crossLinkJson: z.any().nullish(),
    gpId: z.string(),
    seasonAndCompId: z.string(),
  });
}

export function UpdateDriverInputSchema(): z.ZodObject<Properties<UpdateDriverInput>> {
  return z.object({
    driverId: z.string(),
    driverJson: z.any().nullish(),
    editorialDataId: z.string().nullish(),
    seasonAndCompId: z.string(),
    teamId: z.string().nullish(),
  });
}

export function UpdateDriverRankingWidgetInputSchema(): z.ZodObject<Properties<UpdateDriverRankingWidgetInput>> {
  return z.object({
    competitionId: z.string().nullish(),
    competitionLabel: z.string().nullish(),
    items: z.array(z.lazy(() => DriverRankingDriverInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
  });
}

export function UpdateEditorialDataInputSchema(): z.ZodObject<Properties<UpdateEditorialDataInput>> {
  return z.object({
    editorialDataId: z.string(),
    editorialJson: z.any().nullish(),
    isCurrent: z.boolean().nullish(),
    seasonAndCompId: z.string(),
  });
}

export function UpdateGpCalendarWidgetInputSchema(): z.ZodObject<Properties<UpdateGpCalendarWidgetInput>> {
  return z.object({
    competitionId: z.string().nullish(),
    items: z.array(z.lazy(() => GpCalendarItemInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
  });
}

export function UpdateGpCurrentCalendarWidgetInputSchema(): z.ZodObject<
  Properties<UpdateGpCurrentCalendarWidgetInput>
> {
  return z.object({
    competitionId: z.string().nullish(),
    items: z.array(z.lazy(() => GpCalendarItemInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
  });
}

export function UpdateGpDataInputSchema(): z.ZodObject<Properties<UpdateGpDataInput>> {
  return z.object({
    competitionId: z.string().nullish(),
    data: z.any().nullish(),
    gpId: z.string(),
    messageType: z.string().nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
  });
}

export function UpdateGpLiveContainerWidgetInputSchema(): z.ZodObject<Properties<UpdateGpLiveContainerWidgetInput>> {
  return z.object({
    DS: z.lazy(() => GpLiveContainerWrapperInputSchema().nullish()),
    G: z.lazy(() => GpLiveContainerWrapperInputSchema().nullish()),
    R: z.lazy(() => GpLiveContainerWrapperInputSchema().nullish()),
    TS: z.lazy(() => GpLiveContainerWrapperInputSchema().nullish()),
    competitionId: z.string().nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
  });
}

export function UpdateGpLiveHeroWidgetInputSchema(): z.ZodObject<Properties<UpdateGpLiveHeroWidgetInput>> {
  return z.object({
    competitionId: z.string().nullish(),
    gpInfo: z.lazy(() => GpLiveHeroGpInfoInputSchema().nullish()),
    isCurrent: z.boolean().nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
  });
}

export function UpdateGpPodiumListWidgetInputSchema(): z.ZodObject<Properties<UpdateGpPodiumListWidgetInput>> {
  return z.object({
    competitionId: z.string().nullish(),
    grandPrixList: z.array(z.lazy(() => GpPodiumListGrandPrixInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
  });
}

export function UpdateGpResultsContainerWidgetInputSchema(): z.ZodObject<
  Properties<UpdateGpResultsContainerWidgetInput>
> {
  return z.object({
    FP1: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    FP2: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    FP3: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    FP4: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    G: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    GS: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    Q: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    QS: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    R: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    SPRINT: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    SS: z.lazy(() => GpResultsContainerWrapperInputSchema().nullish()),
    competitionId: z.string().nullish(),
    gpId: z.string(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
  });
}

export function UpdateGpResultsWidgetInputSchema(): z.ZodObject<Properties<UpdateGpResultsWidgetInput>> {
  return z.object({
    competitionId: z.string().nullish(),
    gpId: z.string(),
    gpInfo: z.lazy(() => GpResultsGpInfoInputSchema().nullish()),
    gpStatus: z.string().nullish(),
    isCurrent: z.boolean().nullish(),
    seasonAndCompId: z.string().nullish(),
    seasonId: z.string().nullish(),
    sessionName: z.string(),
    sessions: z.array(z.lazy(() => GpResultsSessionInputSchema().nullable())).nullish(),
  });
}

export function UpdateGrandPrixInputSchema(): z.ZodObject<Properties<UpdateGrandPrixInput>> {
  return z.object({
    date: z.string().datetime().nullish(),
    editorialDataId: z.string().nullish(),
    gpId: z.string(),
    gpJson: z.any().nullish(),
    isCurrent: z.boolean().nullish(),
    seasonAndCompId: z.string(),
    status: z.string().nullish(),
  });
}

export function UpdateLgpHeroStickyWidgetInputSchema(): z.ZodObject<Properties<UpdateLgpHeroStickyWidgetInput>> {
  return z.object({
    competitionId: z.string().nullish(),
    gpId: z.string(),
    info: z.lazy(() => LgpHeroStickyInfoInputSchema().nullish()),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
    session: z.lazy(() => LgpHeroStickySessionInputSchema().nullish()),
  });
}

export function UpdateLgpHeroWidgetInputSchema(): z.ZodObject<Properties<UpdateLgpHeroWidgetInput>> {
  return z.object({
    competitionId: z.string().nullish(),
    gpId: z.string(),
    info: z.lazy(() => LgpHeroInfoInputSchema().nullish()),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
    session: z.lazy(() => LgpHeroSessionInputSchema().nullish()),
  });
}

export function UpdateLgpPreviewWidgetInputSchema(): z.ZodObject<Properties<UpdateLgpPreviewWidgetInput>> {
  return z.object({
    calendar: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    competitionId: z.string().nullish(),
    gpId: z.string(),
    gpName: z.string().nullish(),
    gpStartDateTime: z.string().nullish(),
    laps: z.string().nullish(),
    lengthKm: z.string().nullish(),
    news: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    ranking: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    results: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
    sessions: z.array(z.lazy(() => LgpPreviewSessionInputSchema().nullable())).nullish(),
    sportLabel: z.string().nullish(),
  });
}

export function UpdateLgpResultsContainerWidgetInputSchema(): z.ZodObject<
  Properties<UpdateLgpResultsContainerWidgetInput>
> {
  return z.object({
    FP1: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    FP2: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    FP3: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    FP4: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    G: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    GS: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    Q: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    QS: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    R: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    SPRINT: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    SS: z.lazy(() => LgpResultsContainerWrapperInputSchema().nullish()),
    competitionId: z.string().nullish(),
    gpId: z.string(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
  });
}

export function UpdateLgpResultsWidgetInputSchema(): z.ZodObject<Properties<UpdateLgpResultsWidgetInput>> {
  return z.object({
    calendar: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    competitionId: z.string().nullish(),
    gpId: z.string(),
    gpInfo: z.lazy(() => LgpResultsGpInfoInputSchema().nullish()),
    gpStatus: z.string().nullish(),
    isCurrent: z.boolean().nullish(),
    ranking: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    results: z.lazy(() => LgpInfoLinkInputSchema().nullish()),
    seasonAndCompId: z.string().nullish(),
    seasonId: z.string().nullish(),
    sessionName: z.string(),
    sessions: z.array(z.lazy(() => LgpResultsSessionInputSchema().nullable())).nullish(),
  });
}

export function UpdateLiveScoreWidgetInputSchema(): z.ZodObject<Properties<UpdateLiveScoreWidgetInput>> {
  return z.object({
    currentDay: z.array(z.lazy(() => LiveScoreWidgetDayInputSchema().nullable())).nullish(),
    id: z.string(),
    nextDay: z.array(z.lazy(() => LiveScoreWidgetDayInputSchema().nullable())).nullish(),
    previousDay: z.array(z.lazy(() => LiveScoreWidgetDayInputSchema().nullable())).nullish(),
  });
}

export function UpdateSeasonInputSchema(): z.ZodObject<Properties<UpdateSeasonInput>> {
  return z.object({
    seasonId: z.string(),
    seasonJson: z.any().nullish(),
  });
}

export function UpdateSeasonRankingGalleryWidgetInputSchema(): z.ZodObject<
  Properties<UpdateSeasonRankingGalleryWidgetInput>
> {
  return z.object({
    competitionId: z.string().nullish(),
    competitionName: z.string().nullish(),
    competitionsSlugName: z.string().nullish(),
    drivers: z.array(z.lazy(() => SeasonDriverRankingInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
    teams: z.array(z.lazy(() => SeasonTeamRankingInputSchema().nullable())).nullish(),
  });
}

export function UpdateSessionInputSchema(): z.ZodObject<Properties<UpdateSessionInput>> {
  return z.object({
    date: z.string().datetime().nullish(),
    gpId: z.string(),
    isCurrent: z.boolean().nullish(),
    seasonAndCompId: z.string().nullish(),
    sessionId: z.string(),
    sessionJson: z.any().nullish(),
    status: z.string().nullish(),
  });
}

export function UpdateTeamDriverPageWidgetInputSchema(): z.ZodObject<Properties<UpdateTeamDriverPageWidgetInput>> {
  return z.object({
    competitionId: z.string().nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
    teamList: z.array(z.lazy(() => TeamDriverTeamInputSchema().nullable())).nullish(),
  });
}

export function UpdateTeamInputSchema(): z.ZodObject<Properties<UpdateTeamInput>> {
  return z.object({
    editorialDataId: z.string().nullish(),
    seasonAndCompId: z.string(),
    teamId: z.string(),
    teamJson: z.any().nullish(),
  });
}

export function UpdateTeamRankingWidgetInputSchema(): z.ZodObject<Properties<UpdateTeamRankingWidgetInput>> {
  return z.object({
    competitionId: z.string().nullish(),
    competitionLabel: z.string().nullish(),
    items: z.array(z.lazy(() => TeamRankingTeamInputSchema().nullable())).nullish(),
    seasonAndCompId: z.string(),
    seasonId: z.string().nullish(),
  });
}
